import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SceneTemplate } from "@/model";
import templateRepository from "@/repository/templateRepository";
import { scenarioQueryKeys } from "@/query/scenario";
import { templateKeys } from "./keys";


export const useUpdateTemplates = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<SceneTemplate[], Error, FormData>({
        mutationFn: async (formData: FormData) => {
            const data = await templateRepository.update(scenarioId, formData);
            return data.data ?? [];
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: templateKeys.all(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: scenarioQueryKeys.autocompletes(scenarioId) })
            ]);
        }
    });
};
